import { render } from "./match-statistics.vue?vue&type=template&id=17c8d0d8"
import script from "./match-statistics.vue?vue&type=script&lang=js"
export * from "./match-statistics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__